export default "__VITE_ASSET__6d2c6847__"